// Centralized helpers for storing/restoring per-job distance and regenerate flags

const DIST_KEY = (jobId: string | number | undefined | null) => `job:${jobId}:distance_in_miles`;
const REGEN_KEY = (jobId: string | number | undefined | null) => `job:${jobId}:needsRegenerate`;

export type DistanceValue = number | null; // null represents Unlimited

export function setStoredDistance(jobId: string | number | undefined | null, value: DistanceValue): void {
  try {
    localStorage.setItem(DIST_KEY(jobId), String(value));
  } catch (_) {
    /* noop */
  }
}

export function getStoredDistance(jobId: string | number | undefined | null): DistanceValue | undefined {
  try {
    const raw = localStorage.getItem(DIST_KEY(jobId));
    if (raw === null) return undefined; // not set
    if (raw === 'null') return null;
    const num = Number(raw);
    return Number.isNaN(num) ? undefined : num;
  } catch (_) {
    return undefined;
  }
}

export function clearStoredDistance(jobId: string | number | undefined | null): void {
  try {
    localStorage.removeItem(DIST_KEY(jobId));
  } catch (_) {
    /* noop */
  }
}

export function markNeedsRegenerate(jobId: string | number | undefined | null): void {
  try {
    localStorage.setItem(REGEN_KEY(jobId), 'true');
  } catch (_) {
    /* noop */
  }
}


